import React from "react";
import layoutStyle from "../assets/css/modules/shared/layout.css";
import { Urls } from "../constants/UrlConstants";

export default {
  Heading: "Too many incorrect attempts",
  Description:"You've reached the maximum number of attempts to enter your verification code. Please wait and try again shortly.",
  button:"Start again",
  link:(
  <a
                  className={layoutStyle.anchorDecorationUnderline}
                  href={Urls.NeedHelpMFAError}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Need help logging in?
                </a>
  ),
};